import { Search } from "@mui/icons-material"
import { Alert, Button, InputAdornment, MenuItem, Stack, TextField } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import useJsonStore from "../../../services/Hooks/useJsonStore"


export default function FiltersForm({onSubmit}){

    const store = useJsonStore()

    const [data, setData] = useState({
        search: '',
        year: 'all'
    })

    const [errors, setErrors] = useState({})

    useEffect(() => {

        const f = store.get('personFilters');

        if(f) setData(f);

    }, [store])

    const handleSubmit = e => {
        e.preventDefault()

        if(!validate()) return false;

        store.set('personFilters', data)

        return onSubmit(data)
    }

    const validate = () => {

        let e = {};

        if(!data.search && data.year === 'all'){
            e.all = "Vous devez remplir au moins un filtre."
        }

        setErrors(e)

        return Object.keys(e).length === 0;
    }

    return <form onSubmit={handleSubmit}>

        <Stack spacing={3} sx={{maxWidth: 400, margin: 'auto', pt: 6}}>

            {errors.all &&
                <Alert severity='error'>{errors.all}</Alert>
            }

            <TextField
                type='search'
                label='Nom, email, tel, RPPS, SIRET...' 
                value={data.search}
                onChange={e => setData({...data, search: e.target.value})}
                inputProps={{minLength: 3, maxLength: 100}}
                InputProps={{
                    startAdornment: 
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                }}
                size='small'
            />

            <TextField
                select
                label='Année de création' 
                value={data.year}
                onChange={e => setData({...data, year: e.target.value})}
                size='small'
            >
                <MenuItem value='all'>Toutes</MenuItem>
                {[0,1,2,3,4,5,6,7,8,9].map(n => 
                    <MenuItem value={(new Date().getFullYear() - n).toString()} key={n}>
                        {(new Date().getFullYear() - n).toString()}
                    </MenuItem>
                )}
            </TextField>

            <Button variant='contained' type='submit'>
                Valider
            </Button>

        </Stack>

    </form>
}